import {Divider, Typography} from "@mui/material";
import {Grid, Box} from "@mui/system";
import {CopyToClipboardIcon, CustomModal} from "components";
import {DefaultModalFooter} from "components/CustomModal/components";
import pxToRem from "hooks/usePxToRem";
import {CustomButton} from "ui";

type Props = {
  correspondenceText: string;
  correspondenceItems?: string[];
  isOpen: boolean;
  onClose: () => void;
  correspondenceTitle: string;
};

const CorrespondenceModal = (props: Props) => {
  const {
    correspondenceText,
    correspondenceItems,
    isOpen,
    onClose,
    correspondenceTitle,
  } = props;

  const items =
    correspondenceItems && correspondenceItems.length > 0
      ? correspondenceItems
      : [correspondenceText];

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Correspondência - ${correspondenceTitle}`}
      titleIcon="markunread_box"
      maxWidth="xs"
    >
      <Box
        sx={{
          m: pxToRem(20),
          display: "flex",
          flexDirection: "column",
          gap: pxToRem(12),
        }}
      >
        {items.map((item, index) => (
          <Box key={`${item}-${index}`} sx={{width: "100%"}}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: pxToRem(8),
                width: "100%",
              }}
            >
              <CopyToClipboardIcon
                textToBeCopied={item}
                iconSize={24}
                toastText="Correspondência copiada!"
                tooltipPlacement="top"
                tooltipTitle={`Copiar item ${index + 1}`}
              />
              <Typography
                component={"pre"}
                sx={{
                  overflowX: "auto",
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                }}
              >
                {item}
              </Typography>
            </Box>
            {items.length > 1 && index < items.length - 1 && (
              <Divider
                data-testid="correspondence-item-divider"
                sx={{mt: pxToRem(12)}}
              />
            )}
          </Box>
        ))}
      </Box>
      <DefaultModalFooter>
        <Grid container size={12} display="flex" justifyContent="flex-end">
          <Grid size={4}>
            <CustomButton size="small" fullWidth onClickFn={onClose}>
              Fechar
            </CustomButton>
          </Grid>
        </Grid>
      </DefaultModalFooter>
    </CustomModal>
  );
};

export default CorrespondenceModal;
